import { render, staticRenderFns } from "./RefereeEdit.vue?vue&type=template&id=91578ef6&"
import script from "./RefereeEdit.vue?vue&type=script&lang=js&"
export * from "./RefereeEdit.vue?vue&type=script&lang=js&"
import style0 from "./RefereeEdit.vue?vue&type=style&index=0&id=91578ef6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports